/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import SubscriptionsPromoCodesGet200Response from '../model/SubscriptionsPromoCodesGet200Response';

/**
* Subscriptions service.
* @module api/SubscriptionsApi
* @version 1.0.0
*/
export default class SubscriptionsApi {

    /**
    * Constructs a new SubscriptionsApi. 
    * @alias module:api/SubscriptionsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get promo codes applied to a Stripe subscription by customer email
     * Finds the first Stripe customer matching the provided email, fetches the first active or trialing subscription for that customer, and returns all applied promo codes.
     * @param {String} email Customer email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SubscriptionsPromoCodesGet200Response} and HTTP response
     */
    subscriptionsPromoCodesGetWithHttpInfo(email) {
      let postBody = null;
      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling subscriptionsPromoCodesGet");
      }

      let pathParams = {
      };
      let queryParams = {
        'email': email
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SubscriptionsPromoCodesGet200Response;
      return this.apiClient.callApi(
        '/subscriptions/promo-codes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get promo codes applied to a Stripe subscription by customer email
     * Finds the first Stripe customer matching the provided email, fetches the first active or trialing subscription for that customer, and returns all applied promo codes.
     * @param {String} email Customer email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SubscriptionsPromoCodesGet200Response}
     */
    subscriptionsPromoCodesGet(email) {
      return this.subscriptionsPromoCodesGetWithHttpInfo(email)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
